import { Component, OnInit } from '@angular/core';
import { DialogBase } from '@routes/dialogs/dialog.base';
import { Company } from '@shared/enums/company';

@Component({
  selector: 'app-company-selector',
  templateUrl: './company-selector.component.html',
  styleUrls: ['./company-selector.component.scss']
})
export class CompanySelectorComponent extends DialogBase implements OnInit {
  title: any;
  companies: any[];
  readonly Company = Company;

  ngOnInit(): void {
  }

  selectCompany(company: string) {
    this.onClose.next(company);
    this.bsModalRef.hide();
  }

}
